import React, { useEffect, useLayoutEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import HeatMap from "../pages/HeatMap/index";
import PriceCompare from "../pages/PriceCompare/index";
import PricingFiles from "../pages/PricingFiles/index";
import Reports from "../pages/Reports/index";
import EditUser from "../pages/Users/EditUser";

import UserProfileSetting from "../pages/Users/UserProfileSetting";

import Error404Classic from "../pages/PageNotFound/404";

import Login from "../pages/Login/Login";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";
import Error403Classic from "../pages/PageNotFound/403";
import Error500Classic from "../pages/PageNotFound/500";
import PrivacyPolicy from "../pages/PrivacyPolicy/Index";
import TermsAndConditions from "../pages/TermsAndConditions/Index";
import UserListRegularPage from "../pages/Users/index";
import { UserContextProvider } from "../pages/Users/UserContext";

const ProtectedRoute = ({ children }) => {
  const accessToken = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");

  if (!accessToken || !role) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const Pages = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, []);

  return (
    <Routes>
      <Route path={`/`} element={<Layout />}>
        <Route element={<UserContextProvider />}>
          <Route
            index
            element={
              <ProtectedRoute>
                <HeatMap />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="price-compare"
            element={
              <ProtectedRoute>
                <PriceCompare />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="manage-users"
            element={
              <ProtectedRoute>
                <UserListRegularPage />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="edit-user"
            element={
              <ProtectedRoute>
                <EditUser />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="pricing-files"
            element={
              <ProtectedRoute>
                <PricingFiles />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="user-profile-setting"
            element={
              <ProtectedRoute>
                <UserProfileSetting />
              </ProtectedRoute>
            }
          ></Route>
        </Route>
      </Route>

      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route
          path="login"
          element={token && role ? <Navigate to="/" /> : <Login />}
        ></Route>

        <Route
          path="*"
          element={
            token && role ? <Error404Classic /> : <Navigate to="/login" />
          }
        ></Route>
        <Route
          path="/403"
          element={
            token && role ? <Error403Classic /> : <Navigate to="/login" />
          }
        ></Route>

        <Route path="/404" element={<Error404Classic />}></Route>
        <Route path="/403" element={<Error403Classic />}></Route>
        <Route path="/500" element={<Error500Classic />}></Route>
        <Route
          path="/terms-and-conditions"
          element={<TermsAndConditions />}
        ></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
